import { useLocation } from '@reach/router';

import news from '../data/news';
import aboutUs from '../data/about-us';
import homepage from '../data/homepage';
import services from '../data/services';
import fenneq from '../data/fenneq';
import qaser from '../data/qaser';
import useCases from '../data/use-cases';
import resources from '../data/resources';
import technology from '../data/technology';
import quantum101 from '../data/quantum-101';

const useContent = () => {
    const location = useLocation();

    switch (true) {
        case location.pathname === '/':
            return homepage;
        case location.pathname === '/about-us/':
            return aboutUs;
        case location.pathname === '/fenneq/':
            return fenneq;
        case location.pathname === '/qaser/':
            return qaser;
        case location.pathname === '/use-cases/':
            return useCases;
        case location.pathname === '/technology/':
            return technology;
        case location.pathname === '/quantum-101/':
            return quantum101;
        case location.pathname === '/resources/':
            return resources;
        case location.pathname === '/news/':
            return news;
        case location.pathname.includes('/news/'):
            const parsedSlug = location.pathname.replace('/news/', '').replaceAll('/', '');
            return news.list.find(item => item.slug === parsedSlug) || {};
        case location.pathname === '/services/':
            return {};
        case location.pathname.includes('/services/'):
            const parsedServiceSlug = location.pathname.replace('/services/', '').replaceAll('/', '');
            return services.find(service => service.slug === parsedServiceSlug) || {};
        case location.pathname === '/contact/':
        case location.pathname === '/contact':
            return { title: 'Contact Us', isContact: true };
        default:
            return {};
    }
};

export default useContent;
